<template>
  <q-card flat>
    <q-card-section class="no-padding text-center">
      <q-chip color="green-10" text-color="white" label="فروش کل" square>
        <q-badge color="red" text-color="white"
                 :label="lodash.sumBy(items, item=> parseInt(item.SalePay)).toLocaleString()"/>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding text-center">
      <div class="text-subtitle1">پورسانت</div>
      <q-space/>
      <q-chip label="زیرفاکتور" text-color="white" color="indigo" square>
        <q-badge color="green-10" text-color="white"
                 class="q-ml-xs"
                 :label="(Math.round(lodash.sumBy(items, item=> item.Profit * 1/3.0))).toLocaleString()"/>
      </q-chip>
      <q-space/>
      <q-chip label="هدف" text-color="white" color="indigo" square>
        <q-badge color="green-10" class="q-ml-xs" text-color="white"
                 :label="(Math.round(lodash.sumBy(items.filter(item=>item.Sale_PayReceive), item=> item.Target * 2/3.0))).toLocaleString()">
        </q-badge>

        <q-badge color="red" class="q-ml-xs" text-color="white"
                 :label="(Math.round(lodash.sumBy(items.filter(item=>!item.Sale_PayReceive), item=> item.Target * 2/3.0))).toLocaleString()">
        </q-badge>
      </q-chip>
    </q-card-section>
    <q-card-section>
      <q-table
          :data="items"
          row-key="Sale_Num"
          flat
          wrap-cells
          hide-header
          :rows-per-page-options="[pagination.rowsPerPage]"
          :pagination.sync="pagination">
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class">
            <q-card class="shadow-5 q-ma-sm">
              <q-card-section class="text-center no-padding">
                <q-chip :size="$q.screen.lt.md?'md':'md'" square icon="business">
                  {{ props.row.State_Name }}
                </q-chip>
                <q-chip :size="$q.screen.lt.md?'md':'md'" square icon="business">
                  {{ props.row.City_Name }}
                </q-chip>
              </q-card-section>
              <q-card-section class="no-padding text-center">
                <q-chip :size="$q.screen.lt.md?'md':'md'" clickable square color="indigo"
                        text-color="white"
                        icon="qr_code" :label="props.row.Sale_Num" @click="showDetails(props.row)"/>
                <q-chip :size="$q.screen.lt.md?'md':'md'" square color="indigo" text-color="white"
                        icon="qr_code"> {{ props.row.Order_Num }}
                </q-chip>
                <q-chip :size="$q.screen.lt.md?'md':'md'" square
                        color="indigo" text-color="white"
                        icon="qr_code"> {{ props.row.Hava_Num }}
                </q-chip>
              </q-card-section>
              <q-card-section class="no-padding">
                <q-chip :size="$q.screen.lt.md?'md':'md'" square color="red" icon="event" outline>
                  ({{ props.row.Sale_Date }})
                </q-chip>
                <q-chip class="float-right" :size="$q.screen.lt.md?'md':'md'" square color="green-14"
                        icon="attach_money"
                        text-color="white">
                  {{ props.row.Sale_Pay | toCurrency }} ریال
                </q-chip>
              </q-card-section>
              <q-card-section class="text-center no-padding">
                <q-chip square color="deep-orange" text-color="white" v-if="props.row.Target!==0">
                  <span dir="ltr">{{ (Math.round(props.row.Profit * 1 / 3.0)).toLocaleString() }}</span>
                  <q-tooltip>
                    زیر فاکتور
                  </q-tooltip>
                </q-chip>
                <q-space/>
                <q-chip icon="track_changes" square color="deep-orange-10" text-color="white"
                        v-if="(Math.round(props.row.Target * (2/3.0)))">
                  <span dir="ltr">{{ (Math.round(props.row.Target * (2 / 3.0))).toLocaleString() }}</span>
                  <q-tooltip>
                    هدف
                  </q-tooltip>
                </q-chip>
              </q-card-section>
            </q-card>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>

    <q-dialog
        maximized
        v-model="showOrderDetailsDialog">
      <FactorDetails :sale-state="selectedSaleStat" :sale-num="selectedSaleNum"
                     :sale-kind="1" :factor-items="factorItems"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="customerInfoDialog">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>
  </q-card>
</template>

<script>
import FactorDetails from "@/components/Factor/FactorDetails";
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo";

export default {
  name: "AgentFactorListMobile",
  components: {CustomerInfo, FactorDetails},
  props: {
    items: {
      type: [],
      required: true
    },
  },
  data() {
    return {
      customerInfoDialog: false,
      pagination: {
        rowsPerPage: 0
      },
      factorItems: [],
      selectedSaleNum: undefined,
      selectedFactor: undefined,
      showOrderDetailsDialog: false,
      selectedSaleStat: 1,
      selectedCustomer: undefined
    }
  },
  methods: {
    ...mapActions({
      getFactorItems: 'Orders/getFactorItems',
      getCustomerInfo: 'Customers/get_customer_info',
    }),
    showDetails(row) {
      this.getFactorItems({
        sale_num: row.Sale_Num,
        sale_kind: 1
      }).then((res) => {
        this.factorItems = res;
        this.selectedSaleNum = row.Sale_Num;
        this.selectedFactor = row
        this.showOrderDetailsDialog = true;
      })
    },
    showCustomerInfo(row) {
      this.getCustomerInfo(row.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0];
        this.customerInfoDialog = true;
      })
    },
  }
}
</script>

<style scoped>

</style>